import { CalendarClock, Instagram, ClipboardList, Wallet } from "lucide-react";

const ROWS = [
    {
        id: "payment-cycle",
        icon: CalendarClock,
        label: "PAYMENT CYCLE",
        text: "Payments are processed every 7 days for completed and approved work.",
    },
    {
        id: "requirement",
        icon: Instagram,
        label: "REQUIREMENT",
        text: "3 Instagram accounts required.",
    },
    {
        id: "work-type",
        icon: ClipboardList,
        label: "WORK TYPE",
        text: "Upload assigned reels according to the provided instructions.",
    },
    {
        id: "potential-earnings",
        icon: Wallet,
        label: "POTENTIAL EARNINGS",
        text: "₹6,000–₹8,000 per week, depending on completed work, approval, availability, and applicable conditions.",
    },
];

export default function WorkInfo() {
    return (
        <section
            data-testid="work-info-section"
            className="mx-auto w-full max-w-3xl px-4 py-10 md:px-6 md:py-14"
        >
            <h2
                data-testid="work-info-heading"
                className="font-heading text-center text-2xl font-bold tracking-tight text-white md:text-3xl"
            >
                Work <span className="text-[#D4AF37]">Information</span>
            </h2>
            <div
                data-testid="work-info-card"
                className="mt-7 grid grid-cols-1 gap-px overflow-hidden rounded-2xl border border-[#D4AF37]/30 bg-[#D4AF37]/15 md:grid-cols-2"
            >
                {ROWS.map(({ id, icon: Icon, label, text }) => (
                    <div
                        key={id}
                        data-testid={`work-info-row-${id}`}
                        className="flex items-start gap-4 bg-[#101010] p-5 md:p-6"
                    >
                        <span className="mt-0.5 flex h-10 w-10 shrink-0 items-center justify-center rounded-xl border border-[#D4AF37]/40 bg-[#050505]">
                            <Icon className="h-5 w-5 text-[#D4AF37]" strokeWidth={1.8} aria-hidden="true" />
                        </span>
                        <div>
                            <p className="text-[11px] font-bold tracking-[0.2em] text-[#FFD76A]">
                                {label}
                            </p>
                            <p className="mt-1.5 text-sm leading-relaxed text-white md:text-[15px]">
                                {text}
                            </p>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
}
